var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container mt-4 px-10",attrs:{"fluid":""}},[(!_vm.$route.meta.hideBackButton)?_c('base-back-button',{staticClass:"mb-2"}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }